import React, { createContext, useState, useContext } from 'react';
import { InputNumberPadrao, InputPadrao, LoadingContainerPadrao, ModalPadrao } from '../components/Base';
import { BtnAdd, BtnGravar, BtnSair } from '../components/Buttons';
import Mensagens from '../components/Mensagens';
import TabelaPadrao from '../components/TabelaPadrao';
import { Tooltip } from 'antd';
import { FaBoxes } from "react-icons/all";
import InputBlur from '../components/InputBlur';

const ProdutoLoteContext = createContext();

const INITIAL_LOTE = { lote: null, qtd: 0 };

export const ProdutoLoteProvider = ({ children }) => {
    const [produto, setProduto] = useState(null);
    const [callback, setCallback] = useState(null);
    const [lote, setLote] = useState(INITIAL_LOTE);
    const [showAdd, setShowAdd] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleProdutoLote = (prd, cb, fetch) => {
        setShowAdd(true);
        setLoading(true);
        setCallback(() => cb);
        setLote(INITIAL_LOTE);

        if (prd.isLote) {
            const prdInterno = JSON.parse(JSON.stringify({ ...prd, lotes: prd.lotes || [] }));
            setProduto(prdInterno);

            fetch().post(`produto/getlote/${prd.id}`).then(res => {
                const lotesRetorno = res.data || [];
                const aux = [...prdInterno.lotes];
                lotesRetorno.forEach(x => {
                    if (!aux.find(s => s.lote == x.lote))
                        aux.push(x);
                });

                setProduto({ ...prdInterno, lotes: aux });
                setShowAdd(false);
                setLoading(false);

            }).catch(err => {
                console.log(err);
                Mensagens.showErro("Erro ao obter os lotes!");
                setLoading(false);
            });
        }
        else
            cb([]);
    };

    const lotes = produto?.lotes || [];

    const columns = [
        {
            Header: "Lote",
            accessor: "lote",
        },
        {
            Header: "Estoque",
            accessor: "estoque",
            tipo: "dec"
        },
        {
            Header: "Quantidade",
            accessor: "qtd",
            Cell: props => <InputBlur type="number" min={0} value={props.row.original.qtd} onChange={v => {
                const aux = [...lotes];
                aux[props.row.index].qtd = v;
                setProduto({ ...produto, lotes: aux });
            }} />,
            tipo: "right"
        },
    ];

    return <ProdutoLoteContext.Provider value={{ handleProdutoLote }}>
        {children}

        <ModalPadrao title={`Lotes do produto: ${produto?.codigo} - ${produto?.nome || produto?.descricao || produto?.produto}`} width={500} visible={!!produto} onCancel={() => setProduto(null)} footer={<>
            <BtnGravar onClick={() => {
                callback(lotes);
                setProduto(null);
            }} />

            <BtnSair onClick={() => setProduto(null)} />
        </>}>
            <LoadingContainerPadrao loading={loading}>
                <div style={{ minHeight: 150 }}>
                    {showAdd && <div style={{ display: "flex" }}>
                        <InputPadrao value={lote?.lote} onChange={v => setLote({ ...lote, lote: v.target.value })} tabIndex={500} placeholder="Insira o lote" />
                        <InputNumberPadrao min={0} value={lote?.qtd} onChange={v => setLote({ ...lote, qtd: v })} style={{ width: 150, margin: "0 10px" }} tabIndex={501} />
                        <BtnAdd onClick={() => {

                            if (!!lotes.find(x => x.lote == lote.lote))
                                return Mensagens.showWarning("Lote já existe!");

                            setProduto({ ...produto, lotes: [...lotes, { ...lote, id: lotes.length + 1, estoque: 0, quantidade: 0 }] });
                        }} tabIndex={502} nextTab={500} />
                    </div>}

                    <TabelaPadrao style={{ marginTop: showAdd ? 25 : 0 }} columns={columns} data={lotes.map(x => ({ ...x, disableDelete: x.estoque > 0 }))} onDelete={v => {
                        const aux = [...lotes];
                        aux.splice(aux.findIndex(x => x.id == v.id), 1);
                        setProduto({ ...produto, lotes: aux });
                    }} />
                </div>
            </LoadingContainerPadrao>

        </ModalPadrao>
    </ProdutoLoteContext.Provider>;
};

export const EditarLoteIcon = ({ onClick, lotes, isLote, qtd }) => <Tooltip title="Editar lotes">
    <FaBoxes className={qtd != lotes?.reduce((a, b) => a + b.qtd, 0) ? "row-amarelo" : "row-verde"} onClick={onClick} style={{ fontSize: 15, marginLeft: 10, paddingTop: 2, visibility: isLote ? "visible" : "hidden", cursor: "pointer" }} />
</Tooltip>;

export const useProdutoLote = () => useContext(ProdutoLoteContext);